module.exports = __webpack_public_path__ + "img/trituradora-de-papel.7435d93d.png";